import angular from 'angular'
import commonTemplate from 'views/common/template.html'

import { message } from 'redevConfig'
const list = (message && message.list) || ''
const detail = (message && message.detail) || ''
const center = (message && message.center) || ''

const messageInfoPage = list ? require(`redevelopment/main/message/${list.templateName}`) : require('./views/messageInfo.html')
const messageListCtrl = list ? require(`redevelopment/main/message/${list.controllerName}`) : require('./messageListCtrl')

const messageDetail = detail ? require(`redevelopment/main/message/${detail.templateName}`) : require('./views/message.html')
const messageDetailCtrl = detail ? require(`redevelopment/main/message/${detail.controllerName}`) : require('./messageDetailCtrl')

const messageCenter = center ? require(`redevelopment/main/message/${center.templateName}`) : require('./views/message-list.html')
const messageCenterCtrl = center ? require(`redevelopment/main/message/${center.controllerName}`) : require('./messageCenterCtrl')

export default angular
    .module('app.message', [])
    .config([
        '$stateProvider',
        function config ($stateProvider) {
            $stateProvider
                .state('message', {
                    abstract: true,
                    url: '/message',
                    template: commonTemplate,
                    title: '消息中心',
                    default: 'message.center',
                })
                .state('message.center', {
                    url: '/center',
                    template: messageCenter,
                    controller: 'messageCenterCtrl',
                    title: '消息中心',
                })
                .state('message.list', {
                    url: '/list',
                    template: messageInfoPage,
                    controller: 'messageListCtrl',
                    title: '消息中心',
                })
                .state('message.detail', {
                    url: '/detail/:noticeId',
                    template: messageDetail,
                    controller: 'messageDetailCtrl',
                    title: '消息详情',
                })
        },
    ])
    .controller('messageListCtrl', messageListCtrl.default)
    .controller('messageCenterCtrl', messageCenterCtrl.default)
    .controller('messageDetailCtrl', messageDetailCtrl.default).name


// WEBPACK FOOTER //
// ./src/app/main/message/index.js